// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"0a0b0568","531":"4384e119","787":"cda612ba","796":"cdfb45d9","820":"830da530"}[chunkId] + ".chunk.js";
};